var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page4-container" }, [
    _vm.bestBoxes.length > 0
      ? _c(
          "ul",
          { staticClass: "boxes-container" },
          _vm._l(_vm.bestBoxes, function(box) {
            return _c("li", { key: box.id }, [
              _c("div", { staticClass: "box-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "main-image-container",
                    class:
                      _vm.selectedBoxProduct &&
                      _vm.selectedBoxProduct.id == box.id
                        ? "selected"
                        : ""
                  },
                  [
                    _vm.selectedBoxProduct &&
                    _vm.selectedBoxProduct.id == box.id
                      ? _c("img", {
                          staticClass: "green-check",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "main-image",
                      attrs: {
                        width: "280",
                        height: "280",
                        loading: "lazy",
                        src: _vm._f("getProductImage")(box)
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectBox(box)
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "box-title" }, [
                  _vm._v(_vm._s(box.title))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "box-desc" }, [
                  _vm._v(_vm._s(_vm._f("moneyFormat")(box)))
                ]),
                _vm._v(" "),
                _vm.selectedBoxProduct && _vm.selectedBoxProduct.id == box.id
                  ? _c(
                      "button",
                      {
                        staticClass: "happybox-button green border",
                        on: {
                          click: function($event) {
                            return _vm.changePage(true)
                          }
                        }
                      },
                      [_vm._v("Next")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "happybox-button white border",
                        on: {
                          click: function($event) {
                            return _vm.selectBox(box)
                          }
                        }
                      },
                      [_vm._v("Select Design")]
                    )
              ])
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.extendedProducts && _vm.isExtendedBoxes
      ? _c("div", { staticClass: "box-warning w-50" }, [
          _c("img", {
            staticClass: "alert-icon",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/i_icon_554a1a74-64ad-404e-9f6e-47fe1431b3ea.svg?v=1753797241"
            }
          }),
          _vm._v(" "),
          _c("p", [
            _vm._v("Want to see more box options? "),
            _c("br"),
            _vm._v(" Remove "),
            _c("strong", [_vm._v(_vm._s(_vm.extendedProducts))]),
            _vm._v(" to see more designs and sizes!")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-align-center gap-1vw" },
            _vm._l(_vm.noExtendedBoxes, function(box) {
              return _c("div", { staticClass: "flex-1" }, [
                _c("img", {
                  staticClass: "w-100 h-auto",
                  attrs: {
                    width: "280",
                    height: "280",
                    loading: "lazy",
                    src: _vm._f("getProductImage")(box)
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "box-desc" }, [
                  _vm._v(_vm._s(_vm._f("moneyFormat")(box)))
                ])
              ])
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }